import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { postRequest, putRequest } from '../../helpers/apiHandler';
import { useSelector } from 'react-redux'
import validator from 'validator';

const AdminAddEditModal = ({ show, onClose, mode, data, setAlertState, refreshData }) => {
  const { access_token } = useSelector((state) => state.auth.user)
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = () => {
    if (!name || validator.isEmpty(name)) {
      setAlertState({
        message: 'Please enter admin name',
        show: true,
        variant: 'danger',
      });
      return;
    }

    if (!validator.matches(name, /^[a-zA-Z ]+$/)) {
      setAlertState({
        message: 'Admin name must not contain numbers.',
        show: true,
        variant: 'danger',
      });
      return;
    }

    if (!email || validator.isEmpty(email)) {
      setAlertState({
        message: 'Please enter admin email address',
        show: true,
        variant: 'danger',
      });
      return;
    }

    if (!validator.isEmail(email)) {
      setAlertState({
        message: 'Please enter valid email address',
        show: true,
        variant: 'danger',
      });
      return;
    }
    if(mode === "add") {
      createAdmin()
    } else {
      editAdmin()
    }
  };

  const createAdmin = () => {
    if (!password || validator.isEmpty(password)) {
      setAlertState({
        message: 'Please enter your password',
        show: true,
        variant: 'danger',
      });
      return;
    }

    if (
      !validator.matches(
        password,
        /(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+!=]).*$/g
      )
    ) {
      setAlertState({
        message: 'Please choose a strong password that includes at least 1 lowercase and uppercase letter, a number, as well as a special character (!@#$%^&*)',
        show: true,
        variant: 'danger',
      });
      return;
    }

    if (!validator.isLength(password, { min: 8, max: undefined })) {
      setAlertState({
        message: 'The password must be at least 8 characters long.',
        show: true,
        variant: 'danger',
      });
      return;
    }

    if (!confirmPassword || validator.isEmpty(confirmPassword)) {
      setAlertState({
        message: 'Please confirm your password',
        show: true,
        variant: 'danger',
      });
      return;
    }

    if (password !== confirmPassword) {
      setAlertState({
        message: 'Password do not match',
        show: true,
        variant: 'danger',
      });
      return;
    }

    postRequest(`/admin/admin-create`, {name, email, password}, access_token.token, (res) => {
      if (res.success) {
        refreshData()
        onClose()
        setAlertState({
          message: 'New Admin Created',
          show: true,
          variant: 'success',
        });
      } else {
        setAlertState({
          message: 'There was an issue while creating new admin',
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  const editAdmin = () => {
    if (!name) {
      setAlertState({
        message: 'Name is required',
        show: true,
        variant: 'danger',
      });
      return;
    }

    if (!email) {
      setAlertState({
        message: 'email is required',
        show: true,
        variant: 'danger',
      });
      return;
    }
    putRequest(`/admin/admin-update/`+data.id, {name, email}, access_token.token, (res) => {
      if (res.success) {
        refreshData()
        onClose()
        setAlertState({
          message: 'Admin Updated',
          show: true,
          variant: 'success',
        });
      } else {
        setAlertState({
          message: 'There was an issue while updating admin',
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  useEffect(() => {
    if (data) {
      setName(data.name)
      setEmail(data.email)
    }
  }, [data])

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{mode === 'add' ? 'Add New Admin' : 'Edit Admin'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
        <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Control
            type="input"
            value={name} 
            onChange={(event) => setName(event.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Form.Control
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            />
          </Form.Group>
          {mode === 'add' ?
          <>
          <Form.Group>
            <Form.Label>Password</Form.Label>
            <Form.Control
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
            type="password"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            />
          </Form.Group>
          </>
          : <></>
          }
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button
          variant={mode === 'add' ? 'primary' : 'danger'}
          onClick={handleSubmit}
        >
          {mode === 'add' ? 'Save' : 'Edit'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdminAddEditModal;
